import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
// services
import {
  Box,
  CircularProgress,
  Grid,
  MenuItem,
  TextField,
  Typography
} from "@material-ui/core";

import { Formik } from "formik";
import * as Yup from "yup";
import { Autocomplete } from "@material-ui/lab";
import { withAlert } from "react-alert";
import styled from "styled-components";
import SupportService from "../../services/SupportService";
import Button from "../../waybee-ui/Button";
import Group from "../../waybee-ui/Group";
import Heading from "../../waybee-ui/Heading";

const validationSchema = Yup.object().shape({
  typeId: Yup.string().required(),
  reasonId: Yup.string().required(),
  location: Yup.string().required(),
  description: Yup.string()
});

const LoadContainer = styled.div`
  text-align: center;
  margin: 8px;
`;

class Support extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      supportTypes: null,
      supportReasons: null,
      supportClasses: null
    };
  }

  componentDidMount() {
    this.getSupportTypes();
    this.getSupportReasons();
    this.getSupportClasses();
  }

  createSupport = values => {
    const { alert } = this.props;
    this.setState({ loading: true });
    return SupportService.createSupport(values)
      .then(() => {
        alert.show("Suporte enviado com sucesso.", { title: "Novo Suporte" });
      })
      .catch(e => {
        alert.show(e.message, {
          title: "Erro ao Enviar Suporte"
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  getSupportReasons = async () => {
    try {
      this.setState({ loading: true });
      const supportReasons = await SupportService.getSupportReasons();
      this.setState({ supportReasons });
    } finally {
      this.setState({ loading: false });
    }
  };

  getSupportClasses = async () => {
    try {
      this.setState({ loading: true });
      const supportClasses = await SupportService.getSupportClasses();
      this.setState({ supportClasses });
    } finally {
      this.setState({ loading: false });
    }
  };

  getSupportTypes = async () => {
    try {
      this.setState({ loading: true });
      const supportTypes = await SupportService.getSupportTypes();
      this.setState({ supportTypes });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      loading,
      supportTypes,
      supportReasons,
      supportClasses
    } = this.state;

    if (loading)
      return (
        <LoadContainer>
          <CircularProgress />
        </LoadContainer>
      );

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Group>
            <Box>
              <Heading level={1} icon="error_icon" gutterBottom>
                Novo Suporte
                <Box pb={4} pt={2}>
                  <Formik
                    validateOnBlur
                    isInitialValid={false}
                    validateOnChange={false}
                    initialValues={{}}
                    onSubmit={(values, actions) => {
                      this.createSupport(values).then(actions.resetForm);
                    }}
                    validationSchema={validationSchema}
                  >
                    {({
                      values,
                      setFieldValue,
                      errors,
                      handleChange,
                      handleSubmit
                    }) => (
                      <Fragment key="key">
                        <Grid container>
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <Grid item xs={5}>
                                <TextField
                                  select
                                  label="Tipo"
                                  name="typeId"
                                  fullWidth
                                  value={values.typeId || " "}
                                  onChange={handleChange}
                                  error={errors.typeId}
                                  helperText={errors.typeId}
                                >
                                  {supportTypes &&
                                    supportTypes.map(type => (
                                      <MenuItem
                                        key={type.CODIGO}
                                        value={type.MOTIVO}
                                      >
                                        {type.MOTIVO}
                                      </MenuItem>
                                    ))}
                                </TextField>
                              </Grid>
                            </Grid>
                            <Grid item xs={12}>
                              <Grid item xs={5}>
                                <TextField
                                  select
                                  name="reasonId"
                                  label="Motivo"
                                  value={values.reasonId || " "}
                                  onChange={handleChange}
                                  fullWidth
                                  error={errors.reasonId}
                                  helperText={errors.reasonId}
                                >
                                  {supportReasons &&
                                    supportReasons.map(reason => (
                                      <MenuItem
                                        key={reason.CODIGO}
                                        value={reason.MOTIVO}
                                      >
                                        {reason.MOTIVO}
                                      </MenuItem>
                                    ))}
                                </TextField>
                              </Grid>
                            </Grid>
                            <Grid item xs={12}>
                              <Grid item xs={5}>
                                <Autocomplete
                                  id="location"
                                  name="location"
                                  fullWidth
                                  options={supportClasses}
                                  getOptionLabel={options => options.DESCRICAO}
                                  value={values.location}
                                  onChange={(event, locationValue) => {
                                    if (!locationValue) {
                                      setFieldValue("location", null);
                                    } else {
                                      setFieldValue(
                                        "location",
                                        locationValue.DESCRICAO
                                      );
                                    }
                                  }}
                                  renderInput={params => {
                                    return (
                                      <TextField
                                        {...params}
                                        label="Sala"
                                        error={errors.location}
                                        helperText={errors.location}
                                      />
                                    );
                                  }}
                                />
                              </Grid>
                            </Grid>
                            <Grid item xs={12}>
                              <Grid item xs={5}>
                                <Typography
                                  variant="body1"
                                  color="textSecondary"
                                  gutterBottom
                                >
                                  Observações (Opcional):
                                </Typography>
                                <TextField
                                  multiline
                                  rows="4"
                                  variant="outlined"
                                  placeholder="Observação..."
                                  onChange={handleChange}
                                  fullWidth
                                  name="description"
                                  value={values.description || ""}
                                  error={errors.typeIdescription}
                                  helperText={errors.typeIdescription}
                                />
                              </Grid>
                            </Grid>
                            <Grid container justify="center" xs={5}>
                              <Button
                                variant="contained"
                                disabled={loading}
                                // style={{margin: "30px 55px"}}
                                onClick={handleSubmit}
                                color="primary"
                              >
                                Enviar
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Fragment>
                    )}
                  </Formik>
                </Box>
              </Heading>
            </Box>
          </Group>
        </Grid>
      </Grid>
    );
  }
}

Support.propTypes = {
  alert: PropTypes.shape({
    show: PropTypes.func
  }).isRequired
};

export default withAlert()(Support);
